import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import OliverText from "@builder/components/general/OliverText";
import TextInput from "@builder/components/general/TextInput";
import Toggle from "@builder/components/general/Toggle";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { SimpleCartNode } from "@common/build/types";

const EditCartOrderNotes = ({ parent }: EditableProps) => {
    const simpleCartNode = useAppSelector(getSelectedNode) as SimpleCartNode | undefined;
    const dispatch = useAppDispatch();

    return (
        <SidebarCollapse title="Order Notes" parent={parent}>
            <Toggle
                checked={simpleCartNode?.expandedNode.showOrderNotes || false}
                callback={(checked: boolean) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showOrderNotes"], value: checked }));
                }}
                label="Show order notes"
            />
            <OliverText text="Order notes will be shown at the bottom of the cart" size="xxs" />

            <Toggle
                checked={simpleCartNode?.expandedNode.showOrderNotesLabel || false}
                callback={(checked: boolean) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showOrderNotesLabel"], value: checked }));
                }}
                label="Order notes label"
            />
            
            <TextInput
                placeholder="text"
                value={simpleCartNode?.expandedNode.orderNotesLabel || ""}
                callback={(value: string) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "orderNotesLabel"], value }));
                }}
            />
        </SidebarCollapse>
    );
};

export default EditCartOrderNotes;
